export default __webpack_public_path__ + "static/ak-cached/24h/media/8PieceBundle.9aee7b02.png";